/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useState } from 'react';
import { calculateNavigation } from '../Navigation/Navigation';
import ContentTreeGroup from './contentTreeGroup';

// export const globalStore = store({
//   expanded: {} as { [url: string]: boolean },
//   toggleExpanded: (url: string) => {
//     const originalValue = globalStore.expanded[url];
//     const valueToUse = originalValue === undefined ? true : !originalValue;
//     globalStore.expanded[url] = valueToUse;
//   }
// });

const getInitialExpandedNavItems = (treeData, pathname: string) => {
  const res = {};
  for (const group of treeData) {
    for (const child of group.children) {
      res[child.url] =
        pathname === child.url ||
        pathname === `${child.url}/` ||
        child.children.some((nestedChild) => nestedChild.url === pathname || `${nestedChild.url}/` === pathname);
    }
  }
  return res;
};

const ContentTree = ({ edges, location }) => {
  const [treeData] = useState(() => calculateNavigation(edges));
  const [expandedNavItems, setExpandedNavItems] = useState(() =>
    getInitialExpandedNavItems(treeData.children, location.pathname)
  );

  return (
    <div css={{ display: 'flex' }}>
      <div css={{ width: '97.5%' }}>
        {treeData.children.map((groupData) => {
          const key = groupData.path ? groupData.path : Math.random().toString(36).substring(2);
          return (
            <ContentTreeGroup
              expandedNavItems={expandedNavItems}
              setExpandedNavItems={setExpandedNavItems}
              key={key}
              location={location}
              {...groupData}
            />
          );
        })}
      </div>
      <div
        css={{
          width: '1%',
          boxShadow: '2px 2px 10px #3e3e3e',
          backgroundColor: '#222222'
        }}
      />
    </div>
  );
};

export default ContentTree;
